import { randomRange } from "../../../common/common_funcs.js";
import { Vector2 } from "../../../common/vector2.js";
import { VfxConfettiBatch } from "./vfx_confetti_batch.js";

export class VfxConfettiPoint
{
  public static readonly PARTICLES_PER_BURST: number = 70;

  public static readonly MIN_LIFESPAN: number        = 3000;
  public static readonly MAX_LIFESPAN: number        = 4000;
  public static readonly MIN_START_DELAY: number     = 0;
  public static readonly MAX_START_DELAY: number     = 100;

  // Кути пострілу вгору (у градусах, де 90° - строго вгору)
  public static readonly MIN_DEG: number             = 60;
  public static readonly MAX_DEG: number             = 120;

  public static readonly MIN_SPEED: number           = 1.2;
  public static readonly MAX_SPEED: number           = 2.2;

  public static readonly MIN_SPIN: number            = -0.006;
  public static readonly MAX_SPIN: number            = 0.006;

  public static readonly MIN_FLUTTER_AMP: number     = 35;
  public static readonly MAX_FLUTTER_AMP: number     = 50;
  public static readonly MIN_FLUTTER_FREQ: number    = 0.002;
  public static readonly MAX_FLUTTER_FREQ: number    = 0.003;

  public static readonly COLOR_PALETTE: ReadonlyArray<[ number, number, number ]> = [
    [ 1.0, 0.18, 0.24 ], [ 1.0, 0.58, 0.06 ], [ 1.0, 0.9, 0.08 ], [ 0.12, 0.9, 0.36 ],
    [ 0.0, 0.78, 1.0 ], [ 0.38, 0.42, 1.0 ], [ 0.84, 0.24, 1.0 ], [ 1.0, 0.12, 0.72 ],
    [ 1.0, 0.84, 0.0 ], [ 0.2, 1.0, 0.8 ],
  ];

  public static burst( batch: VfxConfettiBatch, center: Vector2, start_time: number ): void
  {
    const scale = LayoutScaler.getScale();

    for ( let i = 0; i < VfxConfettiPoint.PARTICLES_PER_BURST; i++ )
    {
      const spawn_x = center.x;
      const spawn_y = center.y;

      const lifespan     = randomRange( VfxConfettiPoint.MIN_LIFESPAN, VfxConfettiPoint.MAX_LIFESPAN );
      const p_start_time = start_time + randomRange( VfxConfettiPoint.MIN_START_DELAY, VfxConfettiPoint.MAX_START_DELAY );

      const launch_angle = ( randomRange( VfxConfettiPoint.MIN_DEG, VfxConfettiPoint.MAX_DEG ) * Math.PI ) / 180;
      const speed        = randomRange( VfxConfettiPoint.MIN_SPEED, VfxConfettiPoint.MAX_SPEED ) * scale;

      const vel_x = Math.cos( launch_angle ) * speed;
      const vel_y = -Math.sin( launch_angle ) * speed;

      const color_rgb = VfxConfettiPoint.COLOR_PALETTE[
        Math.floor( randomRange( 0, VfxConfettiPoint.COLOR_PALETTE.length ) )
      ];

      const angle         = randomRange( 0, Math.PI * 2 );
      const spin          = randomRange( VfxConfettiPoint.MIN_SPIN, VfxConfettiPoint.MAX_SPIN );
      const frame_index   = Math.floor( randomRange( 0, VfxConfettiBatch.ATLAS_COLS * VfxConfettiBatch.ATLAS_ROWS ) );
      const flutter_phase = randomRange( 0, Math.PI * 2 );
      const flutter_amp   = randomRange( VfxConfettiPoint.MIN_FLUTTER_AMP, VfxConfettiPoint.MAX_FLUTTER_AMP );
      const flutter_freq  = randomRange( VfxConfettiPoint.MIN_FLUTTER_FREQ, VfxConfettiPoint.MAX_FLUTTER_FREQ );

      batch.spawn(
        spawn_x, spawn_y, vel_x, vel_y,
        color_rgb[0], color_rgb[1], color_rgb[2],
        angle, spin, frame_index,
        lifespan, p_start_time,
        flutter_phase, flutter_amp, flutter_freq
      );
    }
  }
}
